/**
 * Section dispatcher —— 单点 dispatch
 * Page 通过 sections 数组编排页面，这里负责 type → 组件的映射
 *
 * 加新 section 类型：
 * 1. 在 src/content/types.ts 的 Section union 加一支
 * 2. 在 src/components/sections/<Name>/ 实现组件
 * 3. 在下面 switch 加一行
 *
 * exhaustive check 保证不漏：types.ts 加新 type 但这里没加，TS 编译失败
 */
import type { Section } from '@/content/types';
import Hero from './Hero/Hero';
import FeatureSplit from './FeatureSplit/FeatureSplit';
import Statement from './Statement/Statement';
import FeatureGrid from './FeatureGrid/FeatureGrid';
import HowItWorks from './HowItWorks/HowItWorks';
import PosterGrid from './PosterGrid/PosterGrid';
import TwoModes from './TwoModes/TwoModes';
import Taskboard from './Taskboard/Taskboard';
import SocialImage from './SocialImage/SocialImage';
import SocialPost from './SocialPost/SocialPost';
import Pricing from './Pricing/Pricing';
import FAQ from './FAQ/FAQ';
import CtaBand from './CtaBand/CtaBand';

export function renderSections(sections: Section[]) {
  return sections.map((s, i) => {
    const key = `${s.type}-${i}`;
    switch (s.type) {
      case 'hero':          return <Hero          key={key} {...s.data} />;
      case 'feature-split': return <FeatureSplit  key={key} {...s.data} />;
      case 'statement':     return <Statement     key={key} {...s.data} />;
      case 'feature-grid':  return <FeatureGrid   key={key} {...s.data} />;
      case 'how-it-works':  return <HowItWorks    key={key} {...s.data} />;
      case 'poster-grid':   return <PosterGrid    key={key} {...s.data} />;
      case 'two-modes':     return <TwoModes      key={key} {...s.data} />;
      case 'taskboard':     return <Taskboard     key={key} {...s.data} />;
      case 'social-image':  return <SocialImage   key={key} {...s.data} />;
      case 'social-post':   return <SocialPost    key={key} {...s.data} />;
      case 'pricing':       return <Pricing       key={key} {...s.data} />;
      case 'faq':           return <FAQ           key={key} {...s.data} />;
      case 'cta-band':      return <CtaBand       key={key} {...s.data} />;
      default: {
        // exhaustive check —— 漏了一支 TS 编译失败
        const _never: never = s;
        return _never;
      }
    }
  });
}
